<style lang="scss" src='./SensorOverview.scss' scoped></style>
<template src="./SensorOverview.html"></template>

<script>
import GwPassword from '@/components/gwPassword/GwPassword.vue';
import GwRing from '@/components/gwRing/GwRing.vue';
import { 
  getSensorRingGraph,
  getHoles,
  getZones,
  editProvisionedSensor,
  editProvisionedSensorPass,
  sendSensorDamagedNotification,
  sendSensorDamagedClearNotification,
  updateSensor,
  sendSensorOutOfGroundNotification,
  sendSensorOutOfGroundClearNotification,
  sendSensorInspectionNotification,
  sendSensorInspectionClearNotification,
  sendSensorOffNotification,
  sendSensorOffClearNotification,
  sendLateSensorNotification,
  sendLateSensorClearNotification,
  getSoilTypes,
  getDailyTemps,
  getSensorIrrigation,
  setSensorIrrigation,
  } from '@/api/index';
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate';
import VueSlider from 'vue-slider-component';
import 'vue-slider-component/theme/antd.css';
import { mapState, mapActions, mapMutations } from 'vuex';
import moment from 'moment';
import i18n from './../../../../i18n';
import messages from './SensorOverview.i18n';
export default {
  name: 'SensorOverview',
  i18n: { messages }, // Irrigated switch
  components: {
    GwPassword,
    GwRing,
    ValidationProvider,
    ValidationObserver,
    VueSlider,
  },
  props: {
    sensor: {
      required: false,
    },
    // latest forecast item (SensorDetails); carries the detected irrigation flag for pilot sensors
    forecast: {
      required: false,
    },
  },
  data() {
    return {
      enviroment: process.env.VUE_APP_SENTRY_ENV,
      iconRssi: null,
      loading: {
        ringsGraph: false,
        saving: false,
        dailyTemps: false,
      },
      clicked:false,
      showOverview: true,
      holes: [],
      zones: [],
      grassTypes: [],
      soilTypes: [],
      location: {
        hole: null,
        zone: null,
        teeMarker: null,
        location: null,
        quadrant: null,
        location_note: null,
        grassType: null,
        soilType: null,
        location_desc: null
      },
      prongsDepth: 2,
      sensorDepth: 0,
      uom: 'DEPTH',
      minValueProngsDepth: null,
      maxValueProngsDepth: null,
      maxValueSensorDepth: 6,
      interval: 0,
      password: null,
      inspection:false,
      observations: null,
      dailyTemps: {},
      irrigationSetting: null, // {mode: on | off | auto, set_by_name, set_at}
      irrigationSaving: false,
      irrigationKey: 0, // bumped to redraw the switch when a save fails
    };
  },
  computed: {
    // The Irrigated switch only means something where the forecast runs (pilot facilities).
    showIrrigation() {
      return !!(this.forecast && ['ok', 'skipped'].includes(this.forecast.status) && this.irrigationSetting);
    },
    irrigationPersonSet() {
      return !!this.irrigationSetting && ['on', 'off'].includes(this.irrigationSetting.mode);
    },
    irrigationDetected() {
      return !!(this.forecast && this.forecast.irrigation && this.forecast.irrigation.detected);
    },
    // What the forecast uses: a person's setting wins, otherwise what the readings show.
    irrigationOn() {
      if (this.irrigationPersonSet) {
        return this.irrigationSetting.mode === 'on';
      }
      return this.irrigationDetected;
    },
    irrigationCaption() {
      if (this.irrigationPersonSet) {
        const s = this.irrigationSetting;
        return this.$t(s.mode === 'on' ? 'irr.confirmedOn' : 'irr.confirmedOff', {
          name: s.set_by_name || '',
          date: moment(s.set_at).format('MMM D'),
        });
      }
      if (this.irrigationDetected) {
        const ev = this.forecast.irrigation.evidence || {};
        return this.$t('irr.detected', {
          n: ev.watering_days,
          window: ev.window_days,
          from: moment({ hour: ev.slot_start_hour || 0 }).format(this.$i18n.locale === 'es' ? 'HH:mm' : 'h a'),
        });
      }
      return this.$t('irr.notDetected');
    },
    ...mapState('sensors', {
      rssiRanges: (state) => state.rssiRanges,
      ringsData: (state) => state.ringsData,
    }),

    ...mapState(['course']),

    isCourseType(){
      if( (this.course.facility_type && this.course.facility_type.is_golf_course) 
      || !this.course.facility_type){
        return true;
      }else{
        return false;
      }
    },
    zonesFiltered: function zonesFilteredFn() {
      if (this.zones && this.zones.length && this.location.hole && 
       this.checkCourseType()) {
        let holeLinked = null;
        holeLinked = this.location.hole;
        return this.zones.filter((zone) =>
          (holeLinked && holeLinked != 'other') ? zone.hole_linked : !zone.hole_linked
        );
      }else if(this.zones && this.zones.length && this.checkCourseType()){
        return this.zones.filter((zone) => !zone.hole_linked
        );
      }else if(!this.checkCourseType()){
        return this.zones;
      }
      return [];
    },
    showNoDataMessage(){
      if(this.ringsData != null && this.ringsData != undefined){
        let objValid = Object.keys(this.ringsData).length;
        if (!objValid) {
          return true
        }
      }
      return false
    },
    getSelectGrassTypeLabel() {
      if(this.checkCourseType() && this.location.zone && this.location.zone.code === 'GB'){
        return i18n.t('sensors.provisionSelectGrassTypeGroundCover');
      }
      return i18n.t('sensors.provisionSelectGrassType');
    },
    getSelectSoilTypeLabel() {
      return i18n.t('sensors.provisionSelectSoilType');
    },
    requiresPasswordToEdit() {
      return (this.$store.state.user.user_type.type_id == this.consts.UserType.AGENT ||
              this.$store.state.user.user_type.type_id == this.consts.UserType.SUPERINTENDENT ||
              this.$store.state.user.user_type.type_id == this.consts.UserType.MANAGER ||
              this.$store.state.user.user_type.type_id == this.consts.UserType.DIRECTOR_AGRONOMY ||
              this.$store.state.user.user_type.type_id == this.consts.UserType.GENERAL_MANAGER ||
              this.$store.state.user.user_type.type_id == this.consts.UserType.COURSE_OPERATIONS ||
              this.$store.state.user.user_type.type_id == this.consts.UserType.DIRECTOR_GOLF ||
              this.$store.state.user.user_type.type_id == this.consts.UserType.HEAD_PROFESSIONAL ||
              this.$store.state.user.user_type.type_id == this.consts.UserType.CLUB_MANAGER ||
              this.$store.state.user.user_type.type_id == this.consts.UserType.GREENSKEEPER ||
              this.$store.state.user.user_type.type_id == this.consts.UserType.SVP_AGRONOMY ||
              this.$store.state.user.user_type.type_id == this.consts.UserType.HEAD_GROUNDSMAN ||
              this.$store.state.user.user_type.type_id == this.consts.UserType.ASSIST_HEAD_GROUNDSMAN ||
              this.$store.state.user.user_type.type_id == this.consts.UserType.HEAD_GROUNDS_PERSON ||
              this.$store.state.user.user_type.type_id == this.consts.UserType.ASSIST_HEAD_GROUNDS_PERSON ||
              this.$store.state.user.user_type.type_id == this.consts.UserType.GROUNDS_SUPERVISOR ||
              this.$store.state.user.user_type.type_id == this.consts.UserType.PARKS_SUPERVISOR ||
              this.$store.state.user.user_type.type_id == this.consts.UserType.PARKS_SUPERINTENDENT ||
              this.$store.state.user.user_type.type_id == this.consts.UserType.SPORTS_TURG_MANAGER ||
              this.$store.state.user.user_type.type_id == this.consts.UserType.DIRECTOR_ATHLETIC_FACILITIES ||
              this.$store.state.user.user_type.type_id == this.consts.UserType.LANDSCAPE_SUPERVISOR ||
              this.$store.state.user.user_type.type_id == this.consts.UserType.DIRECTOR_WATER_MANAGEMENT ||
              this.$store.state.user.user_type.type_id == this.consts.UserType.WATER_MANAGER ||
              this.$store.state.user.user_type.type_id == this.consts.UserType.GROUNDS_MANAGER ||
              this.$store.state.user.user_type.type_id == this.consts.UserType.LEAN_GROUNDSMAN ||
              this.$store.state.user.user_type.type_id == this.consts.UserType.CEO ||
              this.$store.state.user.user_type.type_id == this.consts.UserType.RESEARCH_AGRONOMIST);
    },
    validCoordinates() {
      if(this.sensor && this.sensor.latitude){
        if(this.G_validateLatLong(this.sensor.latitude, this.sensor.longitude)){
          return true;
        }
      }
      return false;
    },
  },
  watch: {
    // the irrigation setting only matters (and is only fetched) where the sensor has a forecast
    forecast: {
      immediate: true,
      handler(fc) {
        if (fc && ['ok', 'skipped'].includes(fc.status) && this.sensor && Number(fc.sensor_id) === Number(this.sensor.sensor_id)) {
          this.loadIrrigation();
        }
      },
    },
    sensor: function (newSensor, oldSensor) {
      if (
        newSensor &&
        oldSensor &&
        newSensor.sensor_id !== oldSensor.sensor_id
      ) {
        this.loadData();
      }
    },
  },

  methods: {
    async loadIrrigation() {
      this.irrigationSetting = null;
      if (!this.sensor) {
        return;
      }
      const sensorId = this.sensor.sensor_id;
      try {
        const res = await getSensorIrrigation(sensorId);
        if (this.sensor && this.sensor.sensor_id === sensorId) {
          this.irrigationSetting = res;
        }
      } catch (e) {
        this.irrigationSetting = null; // endpoint missing or failing: no switch
      }
    },

    // mode: "on" / "off" (a person's setting, wins over detection) or "auto" (back to detection).
    async saveIrrigation(mode) {
      if (!this.sensor || this.irrigationSaving) {
        return;
      }
      this.irrigationSaving = true;
      try {
        this.irrigationSetting = await setSensorIrrigation(this.sensor.sensor_id, mode);
        this.$notify({ type: 'success', text: this.$t('irr.saved') });
      } catch (e) {
        this.irrigationKey += 1; // the API helper shows the error; the switch goes back to the saved state
      } finally {
        this.irrigationSaving = false;
      }
    },

    async notifyOutOfGround() {
      if(this.clicked){
        if (this.sensor) {
          let apiCall = sendSensorOutOfGroundNotification;
          if(!this.sensor.facility_maintenance){
            apiCall = sendSensorOutOfGroundClearNotification;
          }
          await apiCall(this.sensor.course_id, this.sensor.sensor_id)
          .then((sensorEdited) => {
              sensorEdited = {
                ...sensorEdited,
                status: this.sensor.status
              }
              this.setSensor(sensorEdited);
              this.updateSensor(sensorEdited)
            })
            .catch((e) => {});
        
        }
        this.clicked = false;
    }
    },

    async notifyInspection() {
      if(this.clicked){
        if (this.sensor) {
          let apiCall = sendSensorInspectionNotification;
          if(!this.sensor.sensor_inspection){
            apiCall = sendSensorInspectionClearNotification;
          }
          await apiCall(this.sensor.course_id, this.sensor.sensor_id)
          .then((sensorEdited) => {
              sensorEdited = {
                ...sensorEdited,
                status: this.sensor.status
              }
              this.setSensor(sensorEdited);
              this.updateSensor(sensorEdited)
            })
            .catch((e) => {});
        
        }
        this.clicked = false;
    }
    },

    async notifyLateSensor() {
      if(this.clicked){
        if (this.sensor) {
          let apiCall = sendLateSensorNotification;
          if(!this.sensor.late_sensor){
            apiCall = sendLateSensorClearNotification;
          }
          await apiCall(this.sensor.course_id, this.sensor.sensor_id)
          .then((sensorEdited) => {
              sensorEdited = {
                ...sensorEdited,
                status: this.sensor.status
              }
              this.setSensor(sensorEdited);
              this.updateSensor(sensorEdited)
            })
            .catch((e) => {});
        
        }
        this.clicked = false;
    }
      
    },
    

    async notifyDamaged() {
      if(this.clicked){
        if (this.sensor) {
          let apiCall = sendSensorDamagedNotification;
          if(!this.sensor.damaged){
            apiCall = sendSensorDamagedClearNotification;
          }
          await apiCall(this.sensor.course_id, this.sensor.sensor_id)
            .then((sensorEdited) => {
              sensorEdited = {
                ...sensorEdited,
                status: this.sensor.status
              }
              this.setSensor(sensorEdited);
              this.updateSensor(sensorEdited)
            })
            .catch((e) => {});
        }
        this.clicked = false;
    }
    },

    async notifyOff() {
      if(this.clicked){
        if (this.sensor) {
          let apiCall = sendSensorOffNotification;
          if(!this.sensor.sensor_off){
            apiCall = sendSensorOffClearNotification;
          }
          await apiCall(this.sensor.course_id, this.sensor.sensor_id)
          .then((sensorEdited) => {
              sensorEdited = {
                ...sensorEdited,
                status: this.sensor.status
              }
              this.setSensor(sensorEdited);
              this.updateSensor(sensorEdited)
            })
            .catch((e) => {});
        
        }
        this.clicked = false;
    }
    },

    getSIMValue(sim) {
      const simValue = this.consts.SIM.find((item) => item.key == sim);
      if (simValue) {
        return simValue.value;
      }
      return '-';
    },

    getNSValue(ns) {
      const mode = this.consts.NET_SWITCHING.find((item) => item.key == ns);
      if (mode) {
        return i18n.t(mode.value);
      }
      return '-';
    },

    getBLEModeValue(bm) {
      const mode = this.consts.BLE_MODE.find((item) => item.key == bm);
      if (mode) {
        return i18n.t(mode.value);
      }
      return '-';
    },

    checkRequiresPasswordToEdit() {
      return (this.$store.state.user.user_type.type_id == this.consts.UserType.AGENT ||
              this.$store.state.user.user_type.type_id == this.consts.UserType.SUPERINTENDENT ||
              this.$store.state.user.user_type.type_id == this.consts.UserType.MANAGER ||
              this.$store.state.user.user_type.type_id == this.consts.UserType.DIRECTOR_AGRONOMY ||
              this.$store.state.user.user_type.type_id == this.consts.UserType.GENERAL_MANAGER ||
              this.$store.state.user.user_type.type_id == this.consts.UserType.COURSE_OPERATIONS ||
              this.$store.state.user.user_type.type_id == this.consts.UserType.DIRECTOR_GOLF ||
              this.$store.state.user.user_type.type_id == this.consts.UserType.HEAD_PROFESSIONAL ||
              this.$store.state.user.user_type.type_id == this.consts.UserType.CLUB_MANAGER ||
              this.$store.state.user.user_type.type_id == this.consts.UserType.GREENSKEEPER ||
              this.$store.state.user.user_type.type_id == this.consts.UserType.SVP_AGRONOMY ||
              this.$store.state.user.user_type.type_id == this.consts.UserType.HEAD_GROUNDSMAN ||
              this.$store.state.user.user_type.type_id == this.consts.UserType.ASSIST_HEAD_GROUNDSMAN ||
              this.$store.state.user.user_type.type_id == this.consts.UserType.HEAD_GROUNDS_PERSON ||
              this.$store.state.user.user_type.type_id == this.consts.UserType.ASSIST_HEAD_GROUNDS_PERSON ||
              this.$store.state.user.user_type.type_id == this.consts.UserType.GROUNDS_SUPERVISOR ||
              this.$store.state.user.user_type.type_id == this.consts.UserType.PARKS_SUPERVISOR ||
              this.$store.state.user.user_type.type_id == this.consts.UserType.PARKS_SUPERINTENDENT ||
              this.$store.state.user.user_type.type_id == this.consts.UserType.SPORTS_TURG_MANAGER ||
              this.$store.state.user.user_type.type_id == this.consts.UserType.DIRECTOR_ATHLETIC_FACILITIES ||
              this.$store.state.user.user_type.type_id == this.consts.UserType.LANDSCAPE_SUPERVISOR ||
              this.$store.state.user.user_type.type_id == this.consts.UserType.DIRECTOR_WATER_MANAGEMENT ||
              this.$store.state.user.user_type.type_id == this.consts.UserType.WATER_MANAGER ||
              this.$store.state.user.user_type.type_id == this.consts.UserType.GROUNDS_MANAGER ||
              this.$store.state.user.user_type.type_id == this.consts.UserType.LEAN_GROUNDSMAN ||
              this.$store.state.user.user_type.type_id == this.consts.UserType.CEO ||
              this.$store.state.user.user_type.type_id == this.consts.UserType.RESEARCH_AGRONOMIST);
    },

    checkCourseType(){
      if( (this.course.facility_type && this.course.facility_type.is_golf_course) 
      || !this.course.facility_type){
        return true;
      }else{
        return false;
      }
    },

    loadHoles() {
      this.location.hole = null;
      getHoles().then((data) => {
        this.holes = data.holes;
        this.holes.map((hole) => {
          if (hole.hole_id == this.sensor.hole_id) {
            this.location.hole = hole;
          }
        });
      });
    },

    getDepth(value){
      if (this.course.measurement_system == "METRIC") {
          return Math.round(value * 2.54)
      }
      return value
    },

    setDepth(value){
      if (this.course.measurement_system == "METRIC") {
          return value / 2.54
      }
      return value
    },

    getValues(){
      if(this.course.measurement_system == "METRIC"){
        this.prongsDepth = Math.round(this.prongsDepth * 2.54);
        this.sensorDepth = Math.round(this.sensorDepth * 2.54);

        this.minValueProngsDepth = this.sensor.model == 'GX-1F' ? 1 : 5;
        this.maxValueProngsDepth = this.sensor.model == 'GX-1F' ? 91 : 21;
        this.maxValueSensorDepth = 15;
        
        this.interval = 1;

        if(this.course.facility_type && this.course.facility_type.override_max_depth && this.course.facility_type.max_depth){
          this.maxValueSensorDepth = Math.round(this.course.facility_type.max_depth * 2.54);
        }

      }else{
        this.minValueProngsDepth = this.sensor.model == 'GX-1F' ? 0.5 : 2;
        this.maxValueProngsDepth = this.sensor.model == 'GX-1F' ? 36 : 8;

        this.interval = 0.5;
        if(this.course.facility_type && this.course.facility_type.override_max_depth && this.course.facility_type.max_depth){
          this.maxValueSensorDepth = this.course.facility_type.max_depth;
        }
      }
    },

    loadZones() {
      getZones().then((data) => {
        this.zones = data.zones.filter(x => !x.hidden);
        this.grassTypes = data.grass_types

        this.zones.map((zone) => {
          if (zone.zone_id == this.sensor.zone_id 
            && this.checkCourseType()) {
            this.location.zone = zone;
            
            zone.locations.map((location) => {
              if (location.location_id == this.sensor.location_id) {
                this.location.location = location;
              }
            });

            zone.tee_markers.map((tee_marker) => {
              if (tee_marker.tee_marker_id == this.sensor.tee_marker_id) {
                this.location.teeMarker = tee_marker;
              }
            });

            zone.quadrants.map((quadrant) => {
              if (quadrant.quadrant_id == this.sensor.quadrant_id) {
                this.location.quadrant = quadrant;
              }
            });

            if(this.sensor.grass_type_id){
              this.grassTypes.map((grass_type) => {
                if (grass_type.grass_type_id == this.sensor.grass_type_id) {
                  this.location.grassType = grass_type;
                }
              });
            }else{
              this.location.grassType = null;
            }
            
            this.location.location_note = this.sensor.location_note
          } else{

              if(this.sensor.location_desc){
                this.location.location_desc = this.sensor.location_desc;
              }
              
              if(this.sensor.grass_type_id){
                this.grassTypes.map((grass_type) => {
                if (grass_type.grass_type_id == this.sensor.grass_type_id) {
                  this.location.grassType = grass_type;
                }
                });
              }

              if(this.sensor.location_note){
                this.location.location_note = this.sensor.location_note;
              }
          }
        });
      });
    },

    loadSoilTypes() {
      getSoilTypes().then((data) => {
        this.soilTypes = data.soil_types

        if(this.sensor.soil_type_id){
          this.soilTypes.map((soil_type) => {
            if (soil_type.soil_type_id == this.sensor.soil_type_id) {
              this.location.soilType = soil_type;
            }
          });
        }else{
          this.location.soilType = null;
        }

      });
    },

    onChangeHole() {
      this.location.zone = null;
    },
    onChangeZone() {
      this.location.teeMarker = null;
      this.location.location = null;
      this.location.quadrant = null;
      this.location.grassType = null;
      this.location.soilType = null;
      this.location.location_desc = null;
    },

    async loadRssiIcon() {
      if (this.sensor) {
        await this.apiLoadRssiRanges();
        const iconName = this.G_getRssiIcon(this.sensor, this.rssiRanges);
        // eslint-disable-next-line
        this.iconRssi = await require(`@/assets/img/sensor/${iconName}`);
      }
    },

    async loadSensorRingGraph() {
      this.loading.ringsGraph = true;
      const ringsDataReponse = await getSensorRingGraph(this.sensor.sensor_id);

      let data = ringsDataReponse
        ? this.G_getSensorRingsData(ringsDataReponse.data)
        : {};
      this.setRingData(data);
      this.loading.ringsGraph = false;
    },

    async loadDailyTemps() {
      this.loading.dailyTemps = true;
      const dailyResponse = await getDailyTemps(this.sensor.sensor_id);
      this.dailyTemps = {
        min_dielectric: this.G_getMeasurement({
          val: dailyResponse[0].min_dielectric,
          uom: this.consts.UOM.DIELECTRIC,
          addUnit: true,
          invertUOM: false,
        }),
        max_dielectric: this.G_getMeasurement({
          val: dailyResponse[0].max_dielectric,
          uom: this.consts.UOM.DIELECTRIC,
          addUnit: true,
          invertUOM: false,
        }),
        min_temp: this.G_getMeasurement({
          val: dailyResponse[0].min_temp,
          uom: this.consts.UOM.TEMP,
          addUnit: true,
          invertUOM: false,
        }),
        max_temp: this.G_getMeasurement({
          val: dailyResponse[0].max_temp,
          uom: this.consts.UOM.TEMP,
          addUnit: true,
          invertUOM: false,
        }),
        min_salinity_ms: this.G_getMeasurement({
          val: dailyResponse[0].min_salinity,
          uom: this.consts.UOM.SALINITY,
          addUnit: true,
          invertUOM: false,
        }),
        max_salinity_ms: this.G_getMeasurement({
          val: dailyResponse[0].max_salinity,
          uom: this.consts.UOM.SALINITY,
          addUnit: true,
          invertUOM: false,
        }),
        min_salinity: this.G_getMeasurement({
          val: dailyResponse[0].min_salinity / 100,
          uom: this.consts.UOM.SALINITY,
          addUnit: true,
          invertUOM: false,
        }),
        max_salinity: this.G_getMeasurement({
          val: dailyResponse[0].max_salinity / 100,
          uom: this.consts.UOM.SALINITY,
          addUnit: true,
          invertUOM: false,
        }),
        min_moisture: this.G_getMeasurement({
          val: dailyResponse[0].min_moisture,
          uom: this.consts.UOM.MOISTURE,
          addUnit: true,
          invertUOM: false,
        }),
        max_moisture: this.G_getMeasurement({
          val: dailyResponse[0].max_moisture,
          uom: this.consts.UOM.MOISTURE,
          addUnit: true,
          invertUOM: false,
        }),
        min_et: this.G_getMeasurement({
          val: dailyResponse[0].min_et,
          uom: this.consts.UOM.ET_RATE,
          addUnit: true,
          invertUOM: false,
        }),
        max_et: this.G_getMeasurement({
          val: dailyResponse[0].max_et,
          uom: this.consts.UOM.ET_RATE,
          addUnit: true,
          invertUOM: false,
        }),
      };
      this.loading.dailyTemps = false;
    },

    async loadData() {
      this.irrigationSetting = null;
      this.loadRssiIcon();
      this.loadSensorRingGraph();
      this.loadHoles();
      this.loadZones();
      this.loadSoilTypes();
      this.showOverview = true;
      this.sensorDepth = this.sensor.sensor_depth && this.sensor.sensor_depth;
      this.prongsDepth = this.sensor.prongs_depth && this.sensor.prongs_depth;
      this.getValues();
      this.loadDailyTemps();
      
      //this.damaged = this.sensor.damaged;
            
      // this.off = this.sensor.sensor_off;
      this.observations = null;
    },

    editObservations() {
      this.observations = this.sensor.observations;
      this.$bvModal.show('md-edit-observations');
    },

    async saveObservations() {
      this.loading.saving = true;
      const provisionPayload = {'observations': this.observations};
  
      await updateSensor(this.sensor.sensor_id, provisionPayload).then((sensorEdited) => {
        this.setSensor(sensorEdited);
        this.updateSensor(sensorEdited)
        this.observations = null;
        this.loading.saving = false;
        this.$bvModal.hide('md-edit-observations');
      }).finally(() => {
        this.loading.saving = false;
      });
    },

    editProvisioning() {
      if(!this.location.hole && this.location.zone && this.checkCourseType()){
        this.location.hole = 'other';
      }
      this.showOverview = false;
    },

    addValToProvisionPayload(payload, obj, id) {
      if (obj != null) {
        payload[id] = obj[id] ? obj[id] : null;
      }
    },

    async valdiateAskPassword() {
      const valid = await this.validateForm();
      if(valid){
        this.$bvModal.show('md-edit-sensor');
      }
    },

    async saveProvisioningInfo() {
      const valid = await this.validateForm();
      if(valid){

        if(this.checkRequiresPasswordToEdit() && (!this.password && this.password == undefined || this.password === '' )){
          this.$notify({ ignoreDuplicates: true, type: 'warn', text: i18n.t('login.enterYourPassword'), });
          return null;
        }

        if(this.checkCourseType()) {
          this.loading.saving = true;
  
          const provisionPayload = {};
  
          this.addValToProvisionPayload(provisionPayload, this.location.hole, 'hole_id');
          this.addValToProvisionPayload(provisionPayload, this.location.zone, 'zone_id');
          this.addValToProvisionPayload(provisionPayload, this.location.teeMarker, 'tee_marker_id');
          this.addValToProvisionPayload(provisionPayload, this.location.grassType, 'grass_type_id');
          this.addValToProvisionPayload(provisionPayload, this.location.soilType, 'soil_type_id');
          this.addValToProvisionPayload(provisionPayload, this.location.location, 'location_id');
          this.addValToProvisionPayload(provisionPayload, this.location.quadrant, 'quadrant_id');
          provisionPayload.location_desc = this.getLocationDesc();
          provisionPayload.location_code = this.getLocationCode();
          provisionPayload.location_note = this.location.location_note;
          provisionPayload.prongs_depth  = this.setDepth(this.prongsDepth);
          provisionPayload.sensor_depth  = this.setDepth(this.sensorDepth);

          let apiCall = editProvisionedSensor;
          if(this.checkRequiresPasswordToEdit()){
            apiCall = editProvisionedSensorPass;
            provisionPayload.password = this.password;
          }
  
          const activated = await apiCall(this.sensor.sensor_id, provisionPayload)
          .then((sensorEdited) => {
            this.setSensor(sensorEdited);
            this.updateSensor(sensorEdited)
  
            this.loading.saving = false;
            this.showOverview = true;
          })
          .catch((e) => { this.loading.saving = false});
        } else if(!this.checkCourseType()) {
          const provisionPayload = {};
  
          provisionPayload.hole_id      = this.location.hole.hole_id;
          provisionPayload.zone_id      = null;
          this.addValToProvisionPayload(provisionPayload, this.location.grassType, 'grass_type_id');
          this.addValToProvisionPayload(provisionPayload, this.location.soilType, 'soil_type_id');

          provisionPayload.location_desc = this.getLocationDesc();
          provisionPayload.location_code = this.getLocationCode();
          provisionPayload.location_note = this.location.location_note;
          provisionPayload.prongs_depth  = this.setDepth(this.prongsDepth);
          provisionPayload.sensor_depth  = this.setDepth(this.sensorDepth);

          let apiCall = editProvisionedSensor;
          if(this.checkRequiresPasswordToEdit()){
            apiCall = editProvisionedSensorPass;
            provisionPayload.password = this.password;
          }

          const activated = await apiCall(this.sensor.sensor_id, provisionPayload)
          .then((sensorEdited) => {
            this.setSensor(sensorEdited);
            this.updateSensor(sensorEdited)
  
            this.loading.saving = false;
            this.showOverview = true;
          })
          .catch((e) => { this.loading.saving = false});
        }
      }
    },

    getLocationDesc() {
      let desc = '';
      if (this.checkCourseType()) {
        if (this.location.hole.hole_id) {
          const holeNumber = this.location.hole.hole_number;
          desc += (`${this.G_getOrdinalSuffix(holeNumber)}`);
        } else {
          desc += `${this.$t('general.other')}`;
        }
        desc += `, ${this.location.zone.name.toLowerCase()}`;
  
        if (this.location.teeMarker) {
          desc += `, ${this.location.teeMarker.name.toLowerCase()}`;
        }
        if (this.location.location) {
          desc += `, ${this.location.location.name.toLowerCase()}`;
        }
        if (this.location.quadrant) {
          desc += `, ${this.location.quadrant.quadrant} ${this.$t('sensors.yardageOutFromGreen')}`;
        }
        if (this.location.zone.note_required) {
          desc += `, ${this.location.location_note}`;
        }
        return desc;
      } else {
        return `${this.location.location_desc}`
      }
    },

    getLocationCode() {
      let code = '';
      if(this.checkCourseType()){
        if (this.location.hole.hole_id) {
          const holeNumber = this.location.hole.hole_number;
          code += `${holeNumber}`;
        } else {
          code += 'O';
        }
  
        code += `${this.location.zone.code}`;
  
        if (this.location.teeMarker) {
          code += `${this.location.teeMarker.code}`;
        }
        if (this.location.location) {
          code += `${this.location.location.code}`;
        }
        if (this.location.quadrant) {
          code += `${this.location.quadrant.quadrant}`;
        }
      } else if(!this.checkCourseType()) {
        code = `${this.location.hole.hole_number}`
      }
      return code;
    },

    async validateForm() {
      const valid = await this.$refs.validator.validate().then((v) => v);
      return valid;
    },

    returnToOverview() {
      this.loadData();
    },

    ...mapActions('sensors', ['apiLoadRssiRanges']),
    ...mapMutations('sensors', ['setRingData', 'setSensor', 'updateSensor']),
    ...mapMutations('SensorProvisioning', ['setHole']),
  },

  beforeCreate() {},

  created() {},

  mounted() {
    if (process.env.VUE_APP_SENTRY_ENV == "production") {
      this.$analytics.setCurrentScreen("Web Sensors Overview");
      this.$analytics.logEvent("web_sensors_overview");
    }
    this.loadData();
  },
};
</script>
